export default __webpack_public_path__ + "static/media/location-12px-dark.1b4c4589.svg";